import ShadowStyle from 'client/components/core/Sidebar/components/Settings/styles/ShadowStyle'
import { typedPageSelectors, usePage } from 'client/store'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import Input from '../../../components/core/Sidebar/components/Settings/components/Input/Input'
import { SettingsProps } from '../../../components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from '../../../components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import HtmlAttrId from '../../../components/core/Sidebar/components/Settings/options/HtmlAttrId'
import Border from '../../../components/core/Sidebar/components/Settings/styles/Border'
import { useDeviceModeContext } from '../../../context/DeviceModeContext'
import { AttachmentsInterface } from '../entities/Attachments'

function ContactUsSettings({ entity }: SettingsProps<ContactUsInterface>) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  const { t } = useTranslation()

  let editingAttachments
  const pageAttachments = usePage(page =>
    typedPageSelectors.getEntitiesByType(page, EntityTypeEnum.Attachments),
  )

  const contactUschildIds = entity.childIds
  if (contactUschildIds) {
    editingAttachments = pageAttachments.filter(attachmentsEntity =>
      contactUschildIds.includes(attachmentsEntity.id),
    )[0] as AttachmentsInterface
  }

  const updateAttachmentsProp = useUpdateProp(
    editingAttachments as AttachmentsInterface,
  )

  return (
    <>
      <ColorPickerControl
        update={updateProp('backgroundColor')}
        mobileUpdate={updateProp('mobileBackgroundColor')}
        color={entity.backgroundColor}
        mobileColor={entity.mobileBackgroundColor}
        label="settings_styles.background_color.label"
        isClearable
      />
      {editingAttachments && (
        <CheckboxControl
          label={'entity_settings.contact_us.show_attachment'}
          update={updateAttachmentsProp('show')}
          value={editingAttachments && editingAttachments.show}
        />
      )}
      <GroupTitle>
        entity_settings.contact_us.after_submit_text_title
      </GroupTitle>
      <Input
        label="entity_settings.contact_us.after_submit_message_title"
        value={
          entity.successMessageText ||
          t('components.contact_us.success_message')
        }
        update={updateProp('successMessageText')}
        type="text"
      />
      <ColorPickerControl
        update={updateProp('successMessageTextColor')}
        mobileUpdate={updateProp('mobileSuccessMessageTextColor')}
        color={entity.successMessageTextColor}
        mobileColor={entity.mobileSuccessMessageTextColor}
        label="entity_settings.contact_us.after_submit_text_color"
        isClearable
      />
      <Border
        update={updateProp('border')}
        mobileUpdate={updateProp('mobileBorder')}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
      />
      <ShadowStyle
        shadow={entity.boxShadow}
        mobileShadow={entity.mobileBoxShadow}
        update={updateProp('boxShadow')}
        mobileUpdate={updateProp('mobileBoxShadow')}
      />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default ContactUsSettings
